// This file is needed if we'd like to validate that the user can access the site without giving him all our JS/CSS code.
// The only file that should be loaded to unauthorized clients is the compiled version of this file and index.html
// validation.txt is used as a file by which we know whether access is granted
const validationText = require("./validation.txt");

// NOTE: login domain is exported here since when not authorized this is the only file a user may see
export const CQLOUD_LOGIN_DOMAIN = "login.cqloud.com";

function redirect() {
  const urlParams = new URLSearchParams(window.location.search);
  let loginDomain = urlParams.get("loginDomain") || CQLOUD_LOGIN_DOMAIN;
  window.location.assign(`https://${loginDomain}/login?next=${encodeURIComponent(location.href)}`);
}

async function validateAuthorized() {
  try {
    const text = await fetch(validationText, {
      method: "get",
      credentials: "include",
    }).then(response => {
      if (response.status !== 200) {
        redirect();
      }
      return response.text();
    });
    if (!text || text !== "authorized") {
      redirect();
    }
  } catch (e) {
    redirect();
  }
}

validateAuthorized();



// WEBPACK FOOTER //
// ./app/utils/authorizationValidation/authorizationValidation.ts